const EMPTY_RESPONSE = {
  ok: false,
  message: 'Empty response from server',
  data: null
};

const INVALID_RESPONSE = {
  ok: false,
  message: 'Invalid response from server',
  data: null
};

/**
 * Parses standardized Zoho proxy JSON output.
 * Always returns `{ ok, message, data }` where `data` is the full parsed object
 * (or null when the payload is missing or invalid).
 * @returns {{ ok: boolean, message: string, data: object | null }}
 */
export function parseZohoJsonOutput(rawOutput) {
  if (rawOutput == null || rawOutput === '') {
    return { ...EMPTY_RESPONSE };
  }

  let parsed = rawOutput;
  if (typeof rawOutput === 'string') {
    try {
      parsed = JSON.parse(rawOutput);
    } catch {
      return { ...INVALID_RESPONSE };
    }
  }

  if (typeof parsed !== 'object' || parsed === null) {
    return { ...INVALID_RESPONSE };
  }

  return {
    ok: parsed.ok === true,
    message: String(parsed.message ?? '').trim(),
    data: parsed
  };
}

/**
 * Parses standardized Zoho proxy output when only `{ ok, message }` is needed.
 * @returns {{ ok: boolean, message: string }}
 */
export function parseZohoOkMessageOutput(rawOutput) {
  const { ok, message } = parseZohoJsonOutput(rawOutput);
  return { ok, message };
}
